import { EnumOption } from "./enum-option"

export const RecruitmentAdPlace = {
    NA: 0,
    Newspaper: 1,
    Journal: 2,
}

export const RecruitmentAdPlaceList: EnumOption[] = [
    { value: RecruitmentAdPlace.Newspaper, label: 'Newspaper' },
    { value: RecruitmentAdPlace.Journal, label: 'Journal' },
    { value: RecruitmentAdPlace.NA, label: 'N/A' }
]
